import { MDBCheckbox } from "mdb-react-ui-kit";
import React from "react";
import { useTranslation } from "react-i18next";

function CallerACD({ register, errors, setValue }) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="margin-top huntgroup">
        <div className="general-settings">{t("caller")}</div>
        <div className="add-numbermain align-items-start flex-column-sm">
          <div className="tel-numbers">{t("EnACDGreeting")}</div>
          <div className="phoneselect mt-5-sm">
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="phoneselect width-100">
              <audio src="#" controls className="audio-controls" />
            </div>
            <div className="routing-per">
              <span>{t("personalized")}</span>
              <span className="routing-edit">{t("edit")}</span>
            </div>
          </div>
        </div>
        <div className="add-numbermain">
          <div className="tel-numbers">
            {t("MaxCallersallow")}
            <br />
            <span className="phrecording  text-secondary">
              {t("MaxCallersallowtxt")}
            </span>
          </div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <input type="text" value="99" className="selectname w-100" />
            </div>
          </div>
        </div>

        <div className="add-numbermain align-items-start">
          <div className="tel-numbers">
            {t("MuteCallsMax")} <br />
            <span className="phrecording  text-secondary">
              {t("MuteCallsMaxtxt")}
            </span>
          </div>
          <div className="d-flex w-30">
            <div className="w-100">
              <select
                className="form-control form-select w-100"
                name="Default"
              >
                <option value="San Jose">Search...</option>
                <option value="San Jose">San Jose</option>
                <option value="San Jose">San Jose</option>
                <option value="San Jose">San Jose</option>
              </select>

              <div className="mt-2 d-flex align-itemd-center justify-content-between w-100">
                <div className="tel-numbers fw-bold">{t("Timeout")}</div>
                <MDBCheckbox
                  name="checkNoLabel"
                  id="checkboxNoLabel"
                  value=""
                  aria-label="..."
                />
              </div>
              <div className="d-flex w-100">
                <div className="phoneselect w-100">
                  <input
                    disabled
                    type="text"
                    value="120"
                    className="w-100 form-control"
                  />
                  <span className="seconds">{t("seconds")}</span>
                </div>
              </div>

              <div className="mt-2 d-flex align-itemd-start justify-content-between w-100">
                <div className="tel-numbers fw-bold">{t("RouteonTimeout")}</div>
              </div>
              <div className="phoneselect mt-2 w-100">
                <select
                  className="form-control form-select w-100"
                  name="Default"
                  disabled
                >
                  <option value="San Jose">Search...</option>
                  <option value="San Jose">San Jose</option>
                  <option value="San Jose">San Jose</option>
                  <option value="San Jose">San Jose</option>
                </select>
              </div>

              <div className="mt-2 d-flex align-itemd-center justify-content-between w-100">
                <div className="tel-numbers fw-bold">
                  {t("CallerIDpasstrough")}
                </div>
                <MDBCheckbox
                  name="checkNoLabel"
                  id="checkboxNoLabel"
                  value=""
                  aria-label="..."
                />
              </div>
              <div className="phoneselect mt-1">
                <select
                  className="form-control form-select selectname"
                  name="Default"
                  disabled
                >
                  <option value="San Jose">Choose Caller ID...</option>
                  <option value="San Jose">San Jose</option>
                  <option value="San Jose">San Jose</option>
                  <option value="San Jose">San Jose</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="add-numbermain align-items-start">
          <div className="tel-numbers">
            {t("MaxTimeReched")} <br />
            <span className="phrecording  text-secondary">
              {t("MuteCallsMaxtxt")}
            </span>
          </div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <select
                className="form-control form-select selectname"
                name="Default"
              >
                <option value="San Jose">Search...</option>
                <option value="San Jose">San Jose</option>
                <option value="San Jose">San Jose</option>
                <option value="San Jose">San Jose</option>
              </select>
              <div className="mt-2 d-flex align-itemd-center justify-content-between w-100">
                <div className="tel-numbers fw-bold">{t("Timeout")}</div>
                <MDBCheckbox
                  name="checkNoLabel"
                  id="checkboxNoLabel"
                  value=""
                  aria-label="..."
                />
              </div>
              <div className="d-flex w-100">
                <div className="phoneselect w-100">
                  <input
                    disabled
                    type="text"
                    value="120"
                    className="form-control"
                  />
                  <span className="seconds">{t("seconds")}</span>
                </div>
              </div>
              <div className="mt-2 d-flex align-itemd-center justify-content-between w-100">
                <div className="tel-numbers fw-bold">{t("RouteonTimeout")}</div>
              </div>
              <div className="phoneselect mt-2 w-100">
                <select
                  className="form-control form-select selectname"
                  name="Default"
                  disabled
                >
                  <option value="San Jose">Search...</option>
                  <option value="San Jose">San Jose</option>
                  <option value="San Jose">San Jose</option>
                  <option value="San Jose">San Jose</option>
                </select>
              </div>
              <div className="mt-2 d-flex align-itemd-center justify-content-between w-100">
                <div className="tel-numbers fw-bold">
                  {t("CallerIDpasstrough")}
                </div>
                <MDBCheckbox
                  name="checkNoLabel"
                  id="checkboxNoLabel"
                  value=""
                  aria-label="..."
                />
              </div>
              <div className="phoneselect mt-1 w-100">
                <select
                  className="form-control form-select selectname"
                  name="Default"
                  disabled
                >
                  <option value="San Jose">Choose Caller ID...</option>
                  <option value="San Jose">San Jose</option>
                  <option value="San Jose">San Jose</option>
                  <option value="San Jose">San Jose</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="add-numbermain align-items-start mt-3">
          <div className="tel-numbers">
            {t("WheretoRouteCallNoAgents")} <br />
            <span className="phrecording  text-secondary">
              {t("MuteCallsMaxtxt")}
            </span>
          </div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <select
                className="form-control form-select selectname"
                name="Default"
              >
                <option value="San Jose">Search...</option>
                <option value="San Jose">San Jose</option>
                <option value="San Jose">San Jose</option>
                <option value="San Jose">San Jose</option>
              </select>

              <div className="mt-2 d-flex align-itemd-center justify-content-between w-100">
                <div className="tel-numbers fw-bold">{t("Timeout")}</div>
                <MDBCheckbox
                  name="checkNoLabel"
                  id="checkboxNoLabel"
                  value=""
                  aria-label="..."
                />
              </div>
              <div className="d-flex w-100">
                <div className="phoneselect w-100">
                  <input
                    disabled
                    type="text"
                    value="120"
                    className="form-control"
                  />
                  <span className="seconds">{t("seconds")}</span>
                </div>
              </div>

              <div className="mt-2 d-flex align-itemd-center justify-content-between w-100">
                <div className="tel-numbers fw-bold">{t("RouteonTimeout")}</div>
              </div>
              <div className="phoneselect mt-2 w-100">
                <select
                  className="form-control form-select selectname"
                  name="Default"
                  disabled
                >
                  <option value="San Jose">Search...</option>
                  <option value="San Jose">San Jose</option>
                  <option value="San Jose">San Jose</option>
                  <option value="San Jose">San Jose</option>
                </select>
              </div>

              <div className="mt-2 d-flex align-itemd-center justify-content-between w-100">
                <div className="tel-numbers fw-bold">
                  {t("CallerIDpasstrough")}
                </div>
                <MDBCheckbox
                  name="checkNoLabel"
                  id="checkboxNoLabel"
                  value=""
                  aria-label="..."
                />
              </div>
              <div className="phoneselect mt-1 w-100">
                <select
                  className="form-control form-select selectname"
                  name="Default"
                  disabled
                >
                  <option value="San Jose">Choose Caller ID...</option>
                  <option value="San Jose">San Jose</option>
                  <option value="San Jose">San Jose</option>
                  <option value="San Jose">San Jose</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="add-numbermain flex-column-sm">
          <div className="tel-numbers">{t("AnnouncetheCaller")}</div>
          <div className="phoneselect mt-5-sm">
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>

        <div className="add-numbermain flex-column-sm">
          <div className="tel-numbers">{t("AllowpromptEnCaller")}</div>
          <div className="phoneselect mt-5-sm">
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="phoneselect width-100">
              <audio src="#" controls className="audio-controls" />
            </div>
            <div className="routing-per">
              <span>{t("personalized")}</span>
              <span className="routing-edit">{t("edit")}</span>
            </div>
          </div>
        </div>

        <div className="add-numbermain flex-column-sm">
          <div className="tel-numbers">{t("AllowpromptEnCalltransfer")}</div>
          <div className="phoneselect mt-5-sm">
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="phoneselect width-100">
              <audio src="#" controls className="audio-controls" />
            </div>
            <div className="routing-per">
              <span>{t("personalized")}</span>
              <span className="routing-edit">{t("edit")}</span>
            </div>
          </div>
        </div>

        <div className="add-numbermain flex-column-sm">
          <div className="tel-numbers">{t("AllowpromptCallback")}</div>
          <div className="phoneselect mt-5-sm">
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="phoneselect width-100">
              <audio src="#" controls className="audio-controls" />
            </div>
            <div className="routing-per">
              <span>{t("personalized")}</span>
              <span className="routing-edit">{t("edit")}</span>
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">{t("Freqpromptplayed")}</div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <input type="text" value="40" className="selectname w-100" />
              <span className="seconds">{t("seconds")}</span>
            </div>
          </div>
        </div>

        <div className="add-numbermain flex-column-sm">
          <div className="tel-numbers">{t("Audiocallerwait")}</div>
          <div className="phoneselect mt-5-sm">
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="phoneselect width-100">
              <audio src="#" controls className="audio-controls" />
            </div>
            <div className="routing-per">
              <span>{t("personalized")}</span>
              <span className="routing-edit">{t("edit")}</span>
            </div>
          </div>
        </div>

        <div className="add-numbermain flex-column-sm">
          <div className="tel-numbers">
            {t("EnMicACDQues")}
            <br />
            <span className="phrecording  text-secondary">
              This allows a Different Music at Hold Tb be played instead of the
              Account Default Music On Hold
            </span>
          </div>
          <div className="phoneselect mt-5-sm">
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="phoneselect width-100">
              <audio src="#" controls className="audio-controls" />
            </div>
            <div className="routing-per">
              <span>{t("personalized")}</span>
              <span className="routing-edit">{t("edit")}</span>
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">
            Where to route calls is Maximum Time is Reached.
            <br />
            <span className="phrecording  text-secondary">
              Where to route calls is defined via calls Flow
            </span>
          </div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <input
                type="text"
                value="OpenAA: 5000. Auto-Attendant"
                className="selectname w-100"
              />
              <span className="seconds">{t("seconds")}</span>
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">
            Where to route calls if no No Agents are Logged in
            <br />
            <span className="phrecording  text-secondary">
              Where to route calls is defined via calls Flow
            </span>
          </div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <input
                type="text"
                value="OpenAA: 5000. Auto-Attendant"
                className="selectname w-100"
              />
              <span className="seconds">{t("seconds")}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CallerACD;
